import barChart from './barChart.vue';

export default  {
    barChart
};
